export enum BadgeVariant {
    INDIGO_LIGHT = 'indigo-light',
    RED = 'red',
    WHITE = 'white',
}
